<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<!-- <p
  class="ws-margin-params"
  [innerHTML]="displayString"
  *ngIf="!(progress >= 0)"
></p> -->
<div
  *ngIf="buttonFlag != undefined && !whiteBackground"
  class="nvc-width-hundred nvc-background-black"
>
  <p
    class="ws-margin-params"
    [innerHTML]="displayString"
    *ngIf="buttonFlag !== 4"
  ></p>
  <div *ngIf="buttonFlag === 0">
    <button
      class="ws-add-btn ws-outline-none ws-cursor-pointer"
      (click)="yesClicked()"
    >
      YES
    </button>
    <button
      class="ws-add-btn ws-cancel ws-outline-none ws-cursor-pointer"
      (click)="cancelClicked()"
    >
      NO
    </button>
  </div>
  <div *ngIf="buttonFlag === 1">
    <button
      class="ws-add-btn ws-outline-none ws-cursor-pointer"
      (click)="yesClicked()"
    >
      Yes. Complete it.
    </button>
    <button
      class="ws-add-btn ws-cancel ws-outline-none ws-cursor-pointer"
      (click)="cancelClicked()"
    >
      NO
    </button>
  </div>
  <div *ngIf="buttonFlag === 2" class="nvc-text-align-center">
    <button
      class="ws-add-btn ws-outline-none ws-cursor-pointer"
      [ngClass]="data.displayFlag === 4 ? 'ws-yes-btn' : ''"
      (click)="yesClicked()"
    >
      YES
    </button>
    <button
      class="ws-add-btn ws-cancel ws-outline-none ws-cursor-pointer"
      (click)="cancelClicked()"
    >
      NO
    </button>
  </div>
  <div *ngIf="buttonFlag === 3" style="text-align: center">
    <button
      class="ws-add-btn ws-outline-none ws-cursor-pointer"
      [ngClass]="data.displayFlag === 6 ? 'ws-yes-btn' : ''"
      (click)="yesClicked()"
    >
      YES
    </button>
    <button
      class="ws-add-btn ws-cancel ws-outline-none ws-cursor-pointer"
      (click)="cancelClicked()"
    >
      NO
    </button>
  </div>
  <p *ngIf="buttonFlag === 4" class="ws-margin-params nvc-text-align-center">
    Select the reason to leave the room
  </p>
  <div
    *ngIf="buttonFlag === 4 && !isMobileDevice"
    fxLayout
    class="nvc-end-call"
  >
    <div
      fxFlex="25"
      class="nvc-end-tab"
      (click)="clickedBreak(0)"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img class="height" src="assets/icons/coffee-cup.svg" />
      <div class="nvc-text">Break</div>
    </div>
    <div
      fxFlex="25"
      class="nvc-end-tab"
      (click)="clickedBreak(1)"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img class="height" src="assets/icons/customer.svg" />
      <div class="nvc-text">InStore - Customer</div>
    </div>
    <div
      fxFlex="25"
      class="nvc-end-tab"
      (click)="clickedBreak(2)"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img class="height" src="assets/icons/phone-call.svg" />
      <div class="nvc-text">Leave Call</div>
    </div>
    <div
      fxFlex="25"
      class="nvc-end-tab"
      (click)="clickedBreak(3)"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img class="height" src="assets/icons/day-and-night.svg" />
      <div class="nvc-text">End Of the Day</div>
    </div>
  </div>
  <div *ngIf="buttonFlag === 4 && isMobileDevice" fxLayout class="nvc-end-call">
    <div
      fxFlex="50"
      class="nvc-end-tab"
      (click)="clickedBreak(0)"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img class="height" src="assets/icons/coffee-cup.svg" />
      <div class="nvc-text">Break</div>
    </div>
    <div
      fxFlex="50"
      class="nvc-end-tab"
      (click)="clickedBreak(1)"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img class="height" src="assets/icons/customer.svg" />
      <div class="nvc-text">InStore - Customer</div>
    </div>
    <div
      fxFlex="50"
      class="nvc-end-tab"
      (click)="clickedBreak(2)"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img class="height" src="assets/icons/phone-call.svg" />
      <div class="nvc-text">Leave Call</div>
    </div>
    <div
      fxFlex="50"
      class="nvc-end-tab"
      (click)="clickedBreak(3)"
      fxLayout="column"
      fxLayoutAlign="start center"
    >
      <img class="height" src="assets/icons/day-and-night.svg" />
      <div class="nvc-text">End Of the Day</div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" class="position">
    <div
      style="
        width: 25px;
        height: 25px;
        transform: rotateY(0deg) rotate(45deg);
        background-color: black;
        border-right: 1px solid white;
        border-bottom: 1px solid white;
      "
      [ngClass]="{
        'ws-rhombus-box-4': data.isMobileDevice && buttonFlag === 4,
        'ws-rhombus-box':
          (data.isMobileDevice && buttonFlag !== 4) ||
          !(data && data.isMobileDevice)
      }"
    ></div>
  </div>
</div>
<div *ngIf="whiteBackground" class="sc-margin-top-4">
  <p
    class="nvc-text-align-center"
    [innerHTML]="displayString"
    *ngIf="buttonFlag !== 4"
  ></p>
  <div *ngIf="buttonFlag === 2" class="nvc-text-align-center sc-margin-top-2">
    <button
      class="sc-filters ws-outline-none ws-cursor-pointer"
      [ngClass]="data.displayFlag === 4 ? 'ws-yes-btn' : ''"
      (click)="cancelClicked()"
    >
      No
    </button>
    <button
      class="sc-filters sc-background-red ws-outline-none ws-cursor-pointer"
      (click)="yesClicked()"
    >
      Yes
    </button>
  </div>
  <div
    *ngIf="buttonFlag === 0 && data?.displayFlag === 2"
    class="sc-margin-bottom-4 nvc-width-hundred"
    fxLayout="row"
    fxLayoutAlign="space-evenly center"
  >
    <button
      class="ws-add-btn ws-download-yes-btn ws-outline-none ws-cursor-pointer ws"
      (click)="yesClicked()"
    >
      YES
    </button>
    <button
      class="ws-add-btn ws-download-no-btn ws-outline-none ws-cursor-pointer"
      (click)="cancelClicked()"
    >
      NO
    </button>
  </div>
</div>
<div *ngIf="progress >= 0" fxLayout="column" class="nvc-margin-top">
  <div fxLayout="row" fxflex="0.5">
    <div fxFlex="94" fxLayoutAlign="center center" style="font-size: 12px">
      {{
        this.slotService.progressReport
          ? this.slotService.progressReport + "%"
          : " Fetching Data... it may take a few minutes"
      }}
    </div>
    <div fxFlex="6">
      <img
        (click)="hideClicked()"
        style="width: 15px; cursor: pointer"
        src="assets/icons/cancel-red.svg"
        alt="close"
      />
    </div>
  </div>
  <div class="myProgress">
    <div
      [ngStyle]="{
        width:
          (this.slotService.progressReport
            ? this.slotService.progressReport
            : 0) + '%'
      }"
      class="myBar"
    ></div>
  </div>
</div>
